export enum UserStatus {
    COURIER_ACTIVE = 'COURIER_ACTIVE',
    COURIER_IN_REVIEW = 'COURIER_IN_REVIEW',
    COURIER_DECLINED = 'COURIER_DECLINED',
    COURIER_DEACTIVATED = 'COURIER_DEACTIVATED',
    INACTIVE = 'INACTIVE'
}
